<template>
  <section class="jsk-block">
    <div class="container">
      <div class="row text-center">
        <div class="col-12">
          <h6 class="text-uppercase text-title">{{ $t("press.title") }}</h6>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 col-lg-4 col-md-4 col-sm-4 text-lg-right text-center">
          
            <img src="./../assets/images/press/start-up.png" class="w-25 grayscale mt-2" alt="jsleague start-up" />
          
        </div>
        <div class="col-12 col-lg-4 col-md-4 col-sm-4 text-center">
            <img
              src="./../assets/images/press/zf.png"
              class="w-50 mt-2 grayscale"
              alt="jsleague ziarul financiar"
            />
        </div>
        <div class="col-12 col-lg-4 col-md-4 col-sm-4 text-lg-left text-center">
            <img
              src="./../assets/images/press/ifc.png"
              class="w-25 grayscale"
              alt="jsleague innovators for children"
            />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "featured"
};
</script>
